var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLongMiddleFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 30 L 20 30 L 180 20 L 200 20 L 200 180 L 180 180 L 20 170 0 170 ",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 20.6 C 169.1 6.1, 149 7.3, 150 21.8",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 179.4 C 169.1 193.9, 149 192.7, 150 178.2",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 22.3 C 144.1 7.3, 124 8.5, 125 23.5",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 177.7 C 144.1 192.7, 124 191.5, 125 176.5",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 24 C 119.1 8.5, 99 9.7, 100 25.2",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 176 C 119.1 191.5, 99 190.3, 100 174.8",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 25.7 C 94.1 9.7, 74 10.9, 75 26.9",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 95 174.3 C 94.1 190.3, 74 189.1, 75 173.1",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 65,
    x2: 15,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 65,
    x2: 30,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 65,
    x2: 45,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 65,
    x2: 75,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 90,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 65,
    x2: 105,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 65,
    x2: 120,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 65,
    x2: 135,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 65,
    x2: 150,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 65,
    x2: 165,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 65,
    x2: 180,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 65,
    x2: 195,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 135,
    x2: 15,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 135,
    x2: 30,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 135,
    x2: 45,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 135,
    x2: 60,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 135,
    x2: 75,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 135,
    x2: 90,
    y2: 130,
    stroke: "white",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 129,
    x2: 105,
    y2: 124,
    stroke: "white",
    strokeWidth: 4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 123,
    x2: 120,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 123,
    x2: 135,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 123,
    x2: 150,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 123,
    x2: 165,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 123,
    x2: 180,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 123,
    x2: 195,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 100,
    x2: 80,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 100,
    x2: 65,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 100,
    x2: 50,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 100,
    x2: 35,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 100,
    x2: 20,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 100,
    x2: 5,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLongMiddleFront);
export default __webpack_public_path__ + "static/media/FiveLongMiddleFront.1b62acd5b22291143d17fe3143a76a0f.svg";
export { ForwardRef as ReactComponent };